export default __webpack_public_path__ + "static/media/f7.2db0f99b.jpg";